import { generateUniqueString } from "../Helpers/helpers";
import * as cartItemHelpers from "./CartItemHelpers";

export default () => ({
    ...cartItemHelpers,

    duplicateGiftCard(item) {
        let data = {
            quantity: 1,
            id: item.id,
            properties: {
                _gc_item: generateUniqueString(),
            },
        };
        this.$store.cart.addToCart(data);
    },

    removeFromCart(item) {
        this.$store.cart.updateCartItem(item, 0);
    },
});
